import { render } from "./NoPayments.vue?vue&type=template&id=75995dd6&scoped=true&ts=true"
import script from "./NoPayments.vue?vue&type=script&lang=ts"
export * from "./NoPayments.vue?vue&type=script&lang=ts"

import "./NoPayments.vue?vue&type=style&index=0&id=75995dd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75995dd6"]])

export default __exports__